<template>
  <div class="d-flex justify-center" style="margin-left: 32px">
    <!-- <div style="font-size: 16px; margin-bottom: 24px" class="gh-tutor">
      TUTOR
    </div> -->
    <div class="d-block w-100" id="style-2" style="overflow: auto;" v-if="computedDataProgramExercise.length > 0 && !loading">
      <table class="rate-table-new" :style="{width:'80%'}">
        <thead>
          <tr>
            <th style="min-width: 150px; max-width: 150px;background: #4D4CAC;color: #fff;">Chương trình học Tutor</th>
            <th style="min-width: 150px; max-width: 150px;background: #4D4CAC;color: #fff;" v-for="th in firstCol" :key="th.key">{{th.text}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in computedDataProgramExercise" :key="item.name">
            <td><strong>{{item.curriculumName}}</strong></td>
            <td>
              <div class="d-flex justify-center">
                <div class="my-auto">{{item.totalCup}}</div>
                <up-down-scope
                  v-if="item.compareCup && ['increase','decrease'].includes(item.compareCup) && item.comparePointCup"
                  :value="item.comparePointCup"
                  :kind="item.compareCup"
                  :percent="true"
                ></up-down-scope>
              </div>
            </td>
            <td>
              <span>{{item.raiseHand}}</span>
            </td>
            <td>
              <span>{{item.totalCorrectQuestion}}/{{item.totalQuestion}}</span>
            </td>
            <td>
              <div class="d-flex justify-center">
                <div class="my-auto">{{item.averagePoint !== null ? item.averagePoint.toFixed(2) : '--'}}</div>
                <up-down-scope
                  v-if="item.comparePoint && ['increase','decrease'].includes(item.comparePoint) && item.comparePointPoint"
                  :value="item.comparePointPoint"
                  :kind="item.comparePoint"
                ></up-down-scope>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <note-filter-for-date
        :dateTime="filterForm.dateTime"
      ></note-filter-for-date>
    </div>
    <div v-else class="d-flex flex-column justify-center align-center" style="margin-top: 0px; padding-right: 200px">
      <img src="../assets/close-icon.png" alt="" class="mb-2">
      <img src="../assets/no-data-exercise.png" alt="" class="mb-5">
      <span style="color: #828282">
          Học sinh chưa có thông tin điểm
      </span>
    </div>

  </div>
</template>

<script>
import moment from 'moment';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import { mapActions, mapState } from 'vuex';
import { SCHOOL_LEVEL } from '@/helpers/constant';
import NoteFilterForDate from './ModalScoreDetail/NoteFilterForDate.vue';
import UpDownScope from './ModalScoreDetail/UpDownScope.vue';

export default {
  components: { NoteFilterForDate, UpDownScope },
  name: 'ExerciseTab',
  data() {
    return {
      loading: true,
      firstCol: [
        {
          text: 'Tổng số cup',
          key: 'totalCup',
        },
        {
          text: 'Số lần phát biểu',
          key: 'raiseHand',
        },
        {
          text: 'Số câu đúng/Tổng số câu hỏi',
          key: 'totalQuestion',
        },
        {
          text: 'Điểm trung bình',
          key: 'averagePoint',
        },
      ],
    };
  },
  computed: {
    ...mapState('student_detail_bt', ['studentBlendedTutorDetail', 'filterForm', 'dataExercise', 'activeFilterSubject']),
    computedDataProgramExercise() {
      if (this.dataExercise) {
        return this.activeFilterSubject !== 'Tất cả' ? this.dataExercise.chuongtrinh.filter((e) => e.curriculumName.toLowerCase() === this.activeFilterSubject.toLowerCase()) : this.dataExercise.chuongtrinh;
      } return [];
    },
  },
  watch: {
    filterForm: {
      deep: true,
      handler() {
        this.getDataExerciseData();
      },
    },
  },
  async created() {
    if (!this.dataExercise) {
      await this.getDataExerciseData();
    }
    this.loading = false;
  },
  methods: {
    ...mapActions('student_detail_bt', ['setDataExercise']),
    async getDataExerciseData() {
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        const loading = this.$loading.show();
        const range = moment(this.filterForm.dateTime[0]).diff(moment(this.filterForm.dateTime[1]), 'days');
        const response = await BlendedCareRepository.getDataExerciseData({
          id: this.studentBlendedTutorDetail.lms_core_user_id,
          // id: 1172937,
          startTime: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD'),
          endTime: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD'),
          prevStartTime: moment(this.filterForm.dateTime[0]).subtract(1 + Math.abs(range), 'd').format('YYYY-MM-DD'),
          prevEndTime: moment(this.filterForm.dateTime[0]).subtract(1, 'd').format('YYYY-MM-DD'),
          tutorSchoolLevel: this.$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY ? SCHOOL_LEVEL.SECONDARY : null,
          recordId: this.$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY ? this.studentBlendedTutorDetail.id : null,
        });
        if (response.message === 'Success') {
          this.setDataExercise(response.data);
        }
        loading.hide();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  td {
    background: #F9F4F4;
    color: #000;
  }
}
.rate-table-new {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  th {
    padding: 8px;
    min-width: 120px;
  }
  td {
    padding: 8px;
    text-align: center;
  }
}
</style>
<style>
.fix-col {
  position: sticky;
  left: 0;
}
.rate-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.rate-table thead tr th:first-child {
  border-bottom: 1px solid #9747ff73 !important;
}
.rate-table thead tr th:not(:first-child) {
  border-left:  1px solid rgba(151, 71, 255, 0.20);
}
.rate-table thead tr th,
.rate-table tbody tr td:first-child{
  background: #edd8fd;
  padding: 16px;
  min-width: 120px;
}
.rate-table tbody tr td:first-child {
 font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #9747ff73 !important;
}
.rate-table tbody tr {
  text-align: center;
}
.rate-table tbody tr td {
  padding: 8px;
}
.rate-table tbody tr td {
  border-bottom: 1px solid rgba(151, 71, 255, 0.20);
}
@media screen and (max-width: 1440px) {
  .rate-table thead tr th,
  .rate-table tbody tr td:first-child{
    background: #edd8fd;
    padding: 10px;
  }
}
.gh-tutor {
  font-size: 10px;
  border-radius: 16px ;
  margin-right: 12px;
  background: #CD91D7;
  padding: 8px 16px;
  color: white;
  width: fit-content;
  height: fit-content;
}
.content-none {
  color: #000;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}
</style>
